/**
 * Datasource local Auth: responsável apenas por zerar o cache da aplicação.
 */

import localforage from 'localforage';

export interface AuthLocalDataSource {
  clearAllCache(): Promise<void>;
}

const DB_NAME = 'retornaar';
const STORE_NAMES = ['user', 'plans', 'clients', 'services', 'reminders', 'reminder_settings'] as const;

export class AuthLocalForageDataSource implements AuthLocalDataSource {
  async clearAllCache(): Promise<void> {
    await Promise.all(
      STORE_NAMES.map((storeName) =>
        localforage.createInstance({ name: DB_NAME, storeName }).clear()
      )
    );
  }
}
